module.exports = __webpack_public_path__ + "img/expovina-primavera_08(1).32c3288e.jpg";